import React from 'react'
import PageWrapper from './PageHelpers/PageWrapper'
import QuestionsSlider from './QuestionsSlider/QuestionsSlider'

const PageQuestions = () => (
    <PageWrapper className="page-questions">
        <QuestionsSlider />
    </PageWrapper>
)

export default PageQuestions